import * as React from 'react'
import {Text} from 'wix-ui-tpa/Text'
import {Tabs} from 'wix-ui-tpa/Tabs'
import classNames from 'classnames'
import {useEnvironment} from '@wix/yoshi-flow-editor'
import {CloseButton} from '../close-button'
import {classes} from './header.st.css'
import {HeaderProps} from '.'

export const Header = ({
  title,
  closeButtonAsButton,
  className,
  titleClassName,
  tabs,
  activeTabIndex,
  closeModal,
  onTabClick,
}: HeaderProps) => {
  const {isMobile} = useEnvironment()
  const hasTabs = tabs?.length
  const mobileWithTabs = isMobile && hasTabs

  return (
    <div className={classNames(classes.header, className, {[classes.mobileHeaderWithTabs]: mobileWithTabs})}>
      {title ? (
        <Text className={classNames(classes.title, titleClassName, {[classes.mobileTitleWithTabs]: mobileWithTabs})}>
          {title}
        </Text>
      ) : null}
      {hasTabs ? (
        <Tabs className={classes.tabs} items={tabs} activeTabIndex={activeTabIndex} onTabClick={onTabClick} />
      ) : null}
      {closeModal ? (
        <CloseButton
          className={classes.headerCloseButton}
          closeButtonAsButton={closeButtonAsButton}
          closeModal={closeModal}
        />
      ) : null}
    </div>
  )
}
